module.exports = __webpack_public_path__ + "img/Landscape-Color.7503e6cf.jpeg";